import {Component, Input } from '@angular/core';

@Component({
  selector: 'app-ng-tooltip',
  templateUrl: './ng-tooltip.component.html',
  styleUrls: ['./ng-tooltip.component.css']
})
export class NgTooltipComponent {
  @Input() tooltipText: string = '';
  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() event: 'hover' | 'focus' | 'click' = 'hover';


}
